const d3 = require("d3");

export class D3Utils {
    static drag(eltD3, start, dragged, end) {
        let drag = d3
            .drag()
            .on("start", start)
            .on("drag", dragged)
            .on("end", end);
        eltD3.call(drag);
    }
}



// WEBPACK FOOTER //
// ./src/utils/D3Utils.js